import Keycloak from 'keycloak-js'

const keycloak = new Keycloak({
  url: 'https://sso.dokiapp.hu/auth', // base URL
  realm: 'dokiapp-local',
  clientId: 'doki-web',
})

export default keycloak
